import { relations } from 'drizzle-orm'
import {
  AnyPgColumn,
  decimal,
  pgEnum,
  pgTable,
  text,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
} from '../common/utils'
import { employees } from './employee'

/** The bookable window a team falls back to when it sets none of its own. */
export const DEFAULT_BOOKING_START = '08:00'
export const DEFAULT_BOOKING_END = '16:00'

export const timesheetModeEnum = pgEnum('timesheet_mode', [
  'visit_based',
  'office_based',
])

export const teams = pgTable(
  'teams',
  {
    ...getBaseFields(),
    name: text().notNull(),
    leaderEmployeeId: getNullableIdReference((): AnyPgColumn => employees.id),
    timesheetMode: timesheetModeEnum().notNull().default('visit_based'),
    defaultStartTime: text(),
    defaultEndTime: text(),
    // How late work may be *sold* into the day, which is not the same question
    // as when the crew clocks in and out: IV sells to 17:00 off a 8-16 shift,
    // so moving the timesheet hours to match would misfile everyone's day.
    bookingStartTime: text(),
    bookingEndTime: text(),
    officeLatitude: decimal({ precision: 10, scale: 8 }),
    officeLongitude: decimal({ precision: 11, scale: 8 }),
    officeAddress: text(),
  },
  (table) => getBaseIndexes('teams', table),
)

export const teamsRelations = relations(teams, ({ one, many }) => ({
  leader: one(employees, {
    fields: [teams.leaderEmployeeId],
    references: [employees.id],
    relationName: 'teamLeader',
  }),
  members: many(employees, { relationName: 'teamMembers' }),
}))
